import React, { useEffect, useState, useCallback } from 'react';
import PageHeader from '../../components/PageHeader';
import { toast } from 'sonner';
import api, { apiError } from '../../lib/api';
import StatsDashboard from './StatsDashboard';
import AttributeFanDialog from '../../components/AttributeFanDialog';
import { MyWeeklyReportCard } from '../../components/AnalysisWidgets';

export default function MyStats() {
  const [data, setData] = useState({});
  const [period, setPeriod] = useState('7d');
  const [accounts, setAccounts] = useState([]);
  const [attributeSale, setAttributeSale] = useState(null); // vente (à moi) sans fan → à rattacher

  const load = useCallback(async () => {
    try {
      // C-309 (01/10) : le fuseau part AUSSI avec les boutons, pour que « 14 jours » commence a
      // minuit CHEZ la chatteuse. Sans lui, minuit = minuit UTC, decale de 2 a 3 heures.
      const { data } = await api.get('/reports/my-stats', { params: { tz_offset: new Date().getTimezoneOffset(), ...(period === 'all' ? {} : { period }) } });
      setData(data || {});
    } catch (e) {
      toast.error(apiError(e, 'Échec du chargement des stats'));
    }
  }, [period]);
  useEffect(() => { load(); }, [load]);

  // Comptes du chatteur (pour le sélecteur de fan dans le dialogue de rattachement).
  useEffect(() => { api.get('/accounts').then(({ data }) => setAccounts(Array.isArray(data) ? data : [])).catch(() => {}); }, []);

  const setGoal = async (value, type) => {
    try {
      await api.post('/reports/my-goal', { weekly_goal_value: value, weekly_goal_type: type });
      toast.success('Objectif mis à jour');
      load();
    } catch (e) {
      toast.error(apiError(e, "Impossible d'enregistrer l'objectif"));
    }
  };

  return (
    <div className="p-6 md:p-8 max-w-6xl mx-auto fade-in" data-testid="my-stats-page">
      <PageHeader title="Mes stats" subtitle={`Ta performance${data.name ? ' — ' + data.name : ''}`} onRefresh={load} />
      <StatsDashboard
        data={data}
        period={period}
        onPeriod={setPeriod}
        editable={data.editable_goal}
        onSetGoal={setGoal}
        onAttach={setAttributeSale}
      />
      <div className="mt-6"><MyWeeklyReportCard /></div>
      <AttributeFanDialog
        sale={attributeSale}
        accounts={accounts}
        onClose={() => { setAttributeSale(null); load(); }}
      />
    </div>
  );
}
